import {
  bool,
  number,
  string,
  shape,
} from 'prop-types';

const myselfProfilePropTypes = {
  avatarImage: string.isRequired,
  fate: shape({}),
  journalIsPrivate: bool.isRequired,
  mantelpieceItemId: number,
  name: string,
  qualityPickerType: string,
  scrapbookStatusId: number,
};

export default myselfProfilePropTypes;